module.exports = __webpack_public_path__ + "img/wgxfz.7ce93c24.jpg";